// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FtQJC","primary":"styles_primary__fsOQz","outline":"styles_outline__8+5dK","text":"styles_text__F9Bx+"};